import config from "config/config";
import { store } from "redux/store";
import { removeUser, setUser } from "redux/slices/userSlice";
import { removeCsrUser, setCsrUser } from "redux/slices/csrUserSlice";
import { getToken } from "js/formatting/getToken";
export async function refreshToken() {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
  };
  const response = await fetch(
    config.REG_API_BASE_URL + "/Token/refresh",
    options
  );

  if (!response.ok) {
    if (store.getState().user.user?.userId) store.dispatch(removeUser());
    else store.dispatch(removeCsrUser());
    return false;
  } else {
    // update user Object with new token in user store.
    const data = await response.json();
    if (store.getState().user?.user?.token) {
      let loggedinUser = store.getState().user.user;
      let { token: _, ...updatedUser } = loggedinUser;
      updatedUser.token = data.token;
      // update user Object with new token in user store.
      store.dispatch(setUser(updatedUser));
    } else {
      let loggedinUser = store.getState().csrUser.csrUser;
      let { token: _, ...updatedUser } = loggedinUser;
      updatedUser.token = data.token;
      // update user Object with new token in user store.
      store.dispatch(setCsrUser(updatedUser));
    }

    return true;
  }
}
